import React, { useEffect, useRef, useState } from "react";
import Dashboard from "../layouts/Dashboard";
import { Card, Col, Row, Table, Tag, Button, Tooltip } from "antd";
import axios from "../services/axios";
import { message } from "antd";
import moment from "moment";
import ReactLoading from "react-loading";
import { DatePicker } from "antd";
import { useLocation } from "react-router-dom";
import { createGlobalStyle } from "styled-components";
import isConsultant from "../services/isConsultant";
import { Select } from "antd";
import useAxios from "../hooks/useAxios";
import { Radio } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import BASE from "../config";
import { checkBulkPermissions } from "../utils/checkPermission";
import useRole from "../hooks/useRole";

const { RangePicker } = DatePicker;
const { Option } = Select;

const AllApplicationReport = () => {
  const api = useAxios();
  const location = useLocation();
  const userRole = useRole();
  const [startDate, setStartDate] = useState();
  const [defaultDate, setDefaultDate] = useState([moment().subtract(1, 'month'), moment()]);
  const [trfList, setTrfList] = useState([]);
  const [formData, setFormData] = useState([]);
  const [trf, setTrf] = useState("");
  const [formId, setFormId] = useState("");
  const [load, setLoad] = useState(false);
  const [disabbled, setDisabbled] = useState(true);
  const [reportType, setReportType] = useState("");
  const [candidateType, setCandidateType] = useState("Agent");
  const id = localStorage.getItem("user.id");
  const [reportRequests, setReportRequests] = useState([]);
  const [refreshing, setRefreshing] = useState(false);

  const [permissions, setPermissions] = useState({
    canView: false,
    canDownload: false,
    canViewNonAgent: false,
    canViewNewLeads: false
  });
  const [permLoading, setPermLoading] = useState(true);

  const checkPermissions = async () => {
    try {
      const checks = [
        { entityType: "application_report_module", permission: "view_application_report" },
        { entityType: "application_report_module", permission: "download_application_report" },
        { entityType: "application_report_module", permission: "view_non_agent" },
        { entityType: "application_report_module", permission: "view_new_leads" }
      ];

      const results = await checkBulkPermissions(userRole, checks);

      const isAllowed = (perm) => {
        const item = results.find(r => r.permission === perm);
        return item ? item.allowed : false;
      };

      const newPerms = {
        canView: isAllowed("view_application_report"),
        canDownload: isAllowed("download_application_report"),
        canViewNonAgent: isAllowed("view_non_agent"),
        canViewNewLeads: isAllowed("view_new_leads")
      };

      setPermissions(newPerms);

    } catch (err) {
      console.error("Error checking report permissions:", err);
    } finally {
      setPermLoading(false);
    }
  };

  useEffect(() => {
    if (userRole) {
      checkPermissions();
    }
  }, [userRole]);

  const getReportRequests = async (silent = false) => {
    if (!silent) setRefreshing(true);
    try {
      const result = await api.get("/candidateReportRequest", { tokenType: "user" });
      const allReports = result?.data?.CandidateDataReports || [];
      const myReports = allReports.filter(report => report.requestedBy === id);
      setReportRequests(myReports);
    } catch (err) {
      console.log(err);
    } finally {
      if (!silent) setRefreshing(false);
    }
  };

  const deleteReportRequest = async (id) => {
    try {
      await api.delete(`/candidateReportRequest/${id}`, { tokenType: "user" });
      message.success("Request deleted successfully");
      getReportRequests();
    } catch (err) {
      console.log(err);
      message.error("Failed to delete request");
    }
  };

  const handleDownload = async (record) => {
    try {
      // 1. Open the file in a new tab to trigger download
      window.open(`${BASE.api}${record.fileUrl}`, "_blank");

      // 2. Wait 5 seconds then call the cleanup API (PUT) to delete file and deactivate record
      setTimeout(async () => {
        try {
          await api.put(`/candidateReportRequest/${record._id}`, {}, { tokenType: "user" });
          getReportRequests(true);
        } catch (err) {
          console.log("Cleanup error:", err);
        }
      }, 5000);

      message.success("Download started");
    } catch (err) {
      console.log(err);
      message.error("Error during download");
    }
  };

  const submitReport = async () => {
    if (!permissions.canDownload) {
      return message.error("You don't have permission to submit report requests");
    }
    if (!defaultDate[0] || !defaultDate[1]) {
      return message.error("Please select a date range");
    }
    if (defaultDate[1].isAfter(moment(defaultDate[0]).add(3, "month"), "day")) {
      return message.error("You can't select more than 3 months");
    }
    try {
      setLoad(true);
      const payload = {
        filters: {
          startDate: defaultDate[0].format("YYYY-MM-DD"),
          endDate: defaultDate[1].format("YYYY-MM-DD"),
          formId: formId || null,
          candidateType: candidateType || "Agent",
          status: reportType === "Active" ? true : reportType === "InActive" ? false : null,
        }
      };
      await api.post("/candidateReportRequest", payload, { tokenType: "user" });
      message.success("Report request submitted successfully");
      getReportRequests(true);
    } catch (err) {
      console.log(err);
      message.error("Failed to submit report request");
    } finally {
      setLoad(false);
    }
  };

  const handleDate = (value, dateString) => {
    if (value === null) {
      setDefaultDate([
        moment(),
        moment(),
      ]);
    } else {
      let startDate = moment(dateString[0], "YYYY-MM-DD");
      let endDate = moment(dateString[1], "YYYY-MM-DD");
      if (endDate.isAfter(moment(startDate).add(3, "month"), "day")) {
        return message.error("You can't select more than 3 months");
      }
      setDefaultDate([startDate, endDate]);
    }
  };

  const getTrf = () => {
    axios
      .get(`/trf?Department=&Location=&trfStatus=${true}&isTRFAssignable=`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      })
      .then((res) => {
        console.log(res.data);
        setTrfList(res.data);
      });
  };

  const getForm = () => {
    axios
      .get("/formtemplate", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      })
      .then((res) => {
        const data = res.data;
        setFormData(data);
      });
  };

  useEffect(() => {
    const init = async () => {
      await Promise.all([getForm(), getTrf(), getReportRequests()]);
    };
    init();
  }, []);

  const handleCalendarChange = (dates) => {
    if (dates && dates[0]) {
      setStartDate(dates[0]);
    }
  };

  function disableFutureDates(current) {
    const maxDate = startDate
      ? moment(startDate).add(3, "month")
      : moment().endOf("day");
    return current && (current > moment().endOf("day") || current > maxDate);
  }

  const optionsWithDisabled = [
    { label: "All", value: "" },
    { label: "Active", value: "Active" },
    { label: "In Active", value: "InActive" },
  ];

  const onChange4 = ({ target: { value } }) => {
    setReportType(value);
  };

  if (permLoading) {
    return (
      <Dashboard title="Active And Inactive Candidates">
        <Card style={{ textAlign: 'center', padding: '50px' }}>
          <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
          <div style={{ marginTop: '10px' }}>Checking permissions...</div>
        </Card>
      </Dashboard>
    );
  }

  if (!permissions.canView) {
    return (
      <Dashboard title="Active And Inactive Candidates">
        <Card style={{ textAlign: 'center', padding: '50px' }}>
          <h3>Unauthorized</h3>
          <p>You do not have permission to view this report.</p>
        </Card>
      </Dashboard>
    );
  }

  return (
    <Dashboard title="Active And Inactive Candidates">
      {load && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}
      <Card>
        <div className="row ">
          <div className="col-md-3">
            <label htmlFor="candidate photo">
              Select Report Type
              <span style={{ color: "red" }}>*</span>
            </label>
            <div>
              <Radio.Group
                options={optionsWithDisabled}
                onChange={onChange4}
                value={reportType}
                style={{ width: "100%" }}
                optionType="button"
                buttonStyle="solid"
                className={`radio-group ${reportType}`}
              />
              <style jsx>{`
                .radio-group .ant-radio-button-wrapper {
                  border: 1px solid #d9d9d9;
                  transition: all 0.3s;
                }

                .radio-group .ant-radio-button-wrapper:hover {
                  color: #1890ff; /* Default Ant Design hover color */
                }

                .radio-group.Active .ant-radio-button-wrapper-checked {
                  background-color: green;
                  color: white;
                  border-color: green;
                }

                .radio-group.Active .ant-radio-button-wrapper-checked:hover {
                  background-color: #006400; /* Darker green */
                  color: white;
                }

                .radio-group.InActive .ant-radio-button-wrapper-checked {
                  background-color: red;
                  color: white;
                  border-color: red;
                }

                .radio-group.InActive .ant-radio-button-wrapper-checked:hover {
                  background-color: #8b0000; /* Darker red */
                  color: white;
                }

                .radio-group
                  .ant-radio-button-wrapper:not(
                    .ant-radio-button-wrapper-checked
                  ):hover {
                  border-color: #40a9ff; /* Default Ant Design hover border color */
                }
              `}</style>
            </div>
          </div>
          <div className="col-md-4">
            <label htmlFor="candidate photo">
              Select Date
              <span style={{ color: "red" }}>*</span>
            </label>
            <RangePicker
              format="YYYY-MM-DD"
              style={{ width: "100%" }}
              onChange={handleDate}
              onCalendarChange={handleCalendarChange}
              disabledDate={disableFutureDates}
              value={defaultDate}
              placeholder={[
                moment(new Date()).subtract(1, "month").format("YYYY-MM-DD"),
                moment(new Date()).format("YYYY-MM-DD"),
              ]}
            />
          </div>
          <div className="col-md-2">
            <label htmlFor="candidate photo">Select Agent/Non-Agent
              <span style={{ color: "red" }}>*</span>
            </label>
            <Select
              id="agent"
              value={candidateType}
              showSearch
              style={{ width: "100%", height: "37px" }}
              placeholder="Select Form"
              optionFilterProp="children"
              filterOption={(input, option) => {
                return (
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0 ||
                  option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
              }}
              onChange={(value) => setCandidateType(value)}
            >
              <Option value={"Agent"}>Agent</Option>
              {permissions.canViewNonAgent && <Option value={"Non-Agent"}>Non-Agent</Option>}
              {permissions.canViewNewLeads && <Option value={"New-Leads"}>New-Leads</Option>}
            </Select>
          </div>
          <div className="col-md-2">
            <label htmlFor="candidate photo">Select Form</label>
            <Select
              id="process"
              showSearch
              style={{ width: "100%", height: "37px" }}
              placeholder="Select Form"
              optionFilterProp="children"
              filterOption={(input, option) => {
                return (
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0 ||
                  option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
              }}
              onChange={(value) => setFormId(value)}
            >
              <Option value={""}>Select Form</Option>
              {formData?.map(
                (form) =>
                  form?.formType === "Joining_Form" && (
                    <Option value={form?._id}>{form?.name}</Option>
                  )
              )}
            </Select>
          </div>
          <div className="col-md-2 align-items-end d-flex mt-4">
            <button
              className={`btn ${"btn-primary"} btn-block`}
              onClick={submitReport}
              disabled={!permissions.canDownload}
              style={{ opacity: permissions.canDownload ? 1 : 0.6, cursor: permissions.canDownload ? 'pointer' : 'not-allowed' }}
            >
              Submit
            </button>
          </div>
        </div>
      </Card>

      <Card title="Report Submissions" className="mt-4">
        <Table
          dataSource={reportRequests}
          loading={refreshing}
          rowKey="_id"
          columns={[
            {
              title: "Requested At",
              dataIndex: "createdAt",
              key: "createdAt",
              render: (text) => moment(text).format("YYYY-MM-DD HH:mm:ss"),
            },
            {
              title: "Completed At",
              dataIndex: "completedAt",
              key: "completedAt",
              render: (text) => (text ? moment(text).format("YYYY-MM-DD HH:mm:ss") : "-"),
            },
            {
              title: "Filters",
              dataIndex: "filters",
              key: "filters",
              render: (filters) => (
                <div style={{ fontSize: "12px" }}>
                  <div><strong>Date:</strong> {moment(filters?.startDate).format("YYYY-MM-DD")} to {moment(filters?.endDate).format("YYYY-MM-DD")}</div>
                  <div><strong>Type:</strong> {filters?.candidateType}</div>
                  {filters?.formId && (
                    <div>
                      <strong>Form:</strong> {formData.find(f => f._id === filters.formId)?.name || filters.formId}
                    </div>
                  )}
                </div>
              ),
            },
            {
              title: "Status",
              dataIndex: "status",
              key: "status",
              render: (status, record) => {
                let color = "blue";
                if (status === "COMPLETED") color = "green";
                if (status === "FAILED") color = "red";
                if (status === "PROCESSING") color = "orange";

                if (status === "FAILED" && record.error?.message) {
                  return (
                    <Tooltip title={record.error.message}>
                      <Tag color={color} style={{ cursor: "pointer" }}>{status}</Tag>
                    </Tooltip>
                  );
                }
                return <Tag color={color}>{status}</Tag>;
              },
            },
            {
              title: (
                <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                  Actions
                  <Button
                    type="link"
                    icon={<ReloadOutlined />}
                    onClick={() => getReportRequests()}
                    size="small"
                    loading={refreshing}
                  />
                </div>
              ),
              key: "actions",
              render: (_, record) => (
                <div className="d-flex" style={{ gap: "10px" }}>
                  {record.status === "COMPLETED" && record.fileUrl && permissions.canDownload && (
                    <Button
                      type="primary"
                      size="small"
                      onClick={() => handleDownload(record)}
                    >
                      Download
                    </Button>
                  )}
                  {permissions.canDownload && (
                    <Button
                      type="danger"
                      size="small"
                      onClick={() => deleteReportRequest(record._id)}
                      disabled={record.status === "PENDING" || record.status === "PROCESSING"}
                    >
                      Delete
                    </Button>
                  )}
                </div>
              ),
            },
          ]}
        />
      </Card>
    </Dashboard>
  );
};

export default AllApplicationReport;
